import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnchorComponent } from '@design-system/buttons/anchor/anchor.component';
import { BodyLargeComponent } from '@design-system/typography/body-lg/body-large.component';
import { TestIdDirective } from '@design-system/core/test-id.directive';
import { ThemePreferenceService } from '@design-system/theme/theme-preference.service';

/** Shared Unity logo + wordmark for auth shell and nav brand row. */
@Component({
  selector: 'app-unity-brand-lockup',
  templateUrl: './unity-brand-lockup.component.html',
  styleUrls: ['./unity-brand-lockup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, AnchorComponent, BodyLargeComponent, TestIdDirective],
})
export class UnityBrandLockupComponent {
  /** When set, wraps the lockup in `app-a` (e.g. `'/'` for home). */
  @Input() linkTo?: string;

  @Input() tid?: string;

  /** Classes applied to `app-a` when `linkTo` is set (e.g. nav hover layout). */
  @Input() anchorCssClass = '';

  readonly logoColorSrc = 'assets/images/new/Unity_Logo_250x350.svg';
  readonly logoWhiteSrc = 'assets/images/new/Unity_Logo_998x1389_White.svg';

  constructor(readonly theme: ThemePreferenceService) {}
}
